export const profanityReplacements: Record<string, string> = {
  fuck: "heck",
  fucking: "freaking",
  fucked: "messed up",
  fucker: "jerk",
  fuckers: "jerks",
  shit: "stuff",
  shitty: "poor",
  bullshit: "nonsense",
  ass: "butt",
  asshole: "jerk",
  assholes: "jerks",
  damn: "darn",
  damned: "darned",
  dammit: "darn it",
  hell: "heck",
  bitch: "person",
  bitchy: "difficult",
  bitches: "people",
  bastard: "jerk",
  bastards: "jerks",
  crap: "stuff",
  crappy: "poor",
  piss: "annoy",
  pissed: "upset",
  pissing: "annoying",
  suck: "stink",
  sucks: "stinks",
  sucked: "was disappointing",
  sucky: "disappointing",
  screw: "mess",
  screwed: "messed up",
  screwing: "messing",
};
